export enum DevelopmentEnum {
    Dev = "dev",
    Development = "development",
    Preprod = "preprod",
    Release = "release",
}
